﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Circle from 'ol/geom/Circle.js';
import Feature from 'ol/Feature.js';
import Collection from 'ol/Collection.js';
import { Utility } from '../Utility.js';
export { CivilProtectionTool };

/**
 * Class CivilProtectionTool
 */
const CivilProtectionTool = function () {

    // Define this
    var myCivilProtectionTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Hash that contains all reference 
    this._hashReference = {};

    // Feature to save
    this._featureInfo = null;

    // Geojson Format
    this._geojsonFormat = new GeoJSON();

    // Entidades Presentes table counter/id
    this._entidadesPresentesRowCounter = 0;

    // Meios envolvidos table counter/id
    this._meiosEnvolvidosRowCounter = 0;

    // Notas table counter/id
    this._notasRowCounter = 0;

    // Layer civil protection name
    this._LayerCivilProtectionName = "";

    // Id column civil protection
    this._civilProtectionIdColumnName = "";

    // Id operation column name
    this._civilProtectionIdOperationColumnName = "";

    // Hash for reference combo
    this._hashReferenceCombo = {
        section: {}
    };

    // Radius deposition search
    this._radiusSearch = 200;

    // Layer information used in deposition point tool
    this._layerInformation = {};

    // Layer information for fill field
    this._layerInformationFillField = {};

    // Value open operation
    this._valueOpenOperation = "";

    // Value query type operation
    this._valueQueryTypeOperation = "";

    // -- end private variable ------------------------------------------------------------------

    // -- begin public variable ------------------------------------------------------------------

    // feature colection use in civil protection tool
    this.collectionFeatureSet = new Collection();

    // -- end public variable ------------------------------------------------------------------

    // -- begin public method -------------------------------------------------------------------

    /**
     * Fill hash freguesia
     * @param {array} freguesiasData, array of freguesia
     */
    this.FillFreguesiaList = function (freguesiasData) {
        freguesiasData.forEach(x => {
            myCivilProtectionTool._hashReference['freguesia_list'].push({ "id": x.IDFREGUESIA, "value": x.FREGUESIA });
        });

        myCivilProtectionTool._utility.FillSelect('id-civilProtectionToolFreguesia', myCivilProtectionTool._hashReference['freguesia_list'], 'value', 'id', true);
    };

    /**
     * Build detail information
     * @param {object} featureInfo, all information of the occurrence
     */
    this.DetailElement = function (featureInfo)
    {
        myCivilProtectionTool._featureInfo = featureInfo;

        // If permission to edit then transform read on update
        if (myCivilProtectionTool._mapSgs._settings._mapSettings.operation_visible.EditLayers)
        {
            if(featureInfo.mode === 'read')
                featureInfo.mode = 'update';
        }

        myCivilProtectionTool._hashReference['entidades_presentes_list'] = [];
        myCivilProtectionTool._hashReference['meios_envolvidos_list'] = [];
        myCivilProtectionTool._hashReference['notas_list'] = [];
        var codElement = "";

        // Start wait
        myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean Number of file
        $('.offcanvas-body-layer-detail-attachment-info-td span')[0].innerHTML = "-";

        // Define according to mode
        var readOnly = "readonly";
        var hiddenCol = false;
        switch (featureInfo.mode) {
            case 'update':
                // ajust button
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').removeClass('col-md-12');
                $('#id-save-feature-submit').addClass('col-md-6');
                $('#id-delete-feature-submit-zone').removeClass('ol-hidden');

                // Event save feature
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myCivilProtectionTool._SaveFeature(featureInfo.mode, featureInfo.fromMap);
                });

                // Event delete feature
                $('#id-delete-feature-submit').off('click').on('click', function () {
                    var idOccurrence = featureInfo.feature.getProperties()[myCivilProtectionTool._civilProtectionIdColumnName];
                    myCivilProtectionTool.DeleteOccurrence(idOccurrence);
                });

                readOnly = "";
                break;
            case 'create':
                // Ajust button
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').removeClass('col-md-6');
                $('#id-save-feature-submit').addClass('col-md-12');
                $('#id-delete-feature-submit-zone').addClass('ol-hidden');

                // Event create feature
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myCivilProtectionTool._SaveFeature(featureInfo.mode, featureInfo.fromMap);
                });

                readOnly = "";
                break;
            default: // read
                $('#id-offcanvas-body-layer-detail-button').addClass('ol-hidden');
        }

        // Show canvas
        myCivilProtectionTool._utility.ShowOpenCanvas3('id-offcanvas-layer-detail', true);

        // Layer info
        var layerObj = myCivilProtectionTool._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;
        var layerPrettyName = layerObj.layer_info.pretty_name;

        // Get codElement
        if (featureInfo.feature.getProperties().import_code)
            codElement = featureInfo.feature.getProperties().import_code;

        // Build title
        $('#id-offcanvas-head-title-element')[0].innerHTML = layerObj.layer_info.pretty_name;
        $('#id-offcanvas-head-code-element')[0].innerHTML = codElement;

        // -- Fields -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-detail-field').empty();

        var gpName = myCivilProtectionTool._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy;

        layerObj.list_column.sort(myCivilProtectionTool._Compare);

        // Build Info field
        for (var i = 0; i < layerObj.list_column.length; i++)
        {
            var objColumn = layerObj.list_column[i];

            // Show only if field marked as visible
            if (!objColumn.visible) continue;

            // Show only if field marked as editable for creations
            if (!objColumn.editable && featureInfo.mode == 'create') continue;

            if (objColumn.editable && (featureInfo.mode == 'update' || featureInfo.mode == 'create')) {
                readOnly = '';
                if (featureInfo.mode == 'update' && (objColumn.column_name == 'zone' || objColumn.column_name == 'id_zone')) {
                    readOnly = 'readonly'; // Cannot update zone in model (Update DB procedures to change this)
                }
            } else {
                readOnly = 'readonly';
            }

            // Change condition according to GP to not include ID fields (myTooltips._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA')
            //if (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 2).toUpperCase() !== 'ID') {
            if ((objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 6).toUpperCase() === 'ID_REF')
                || (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ')) {

                let value = featureInfo.feature.getProperties()[objColumn.column_name];

                let isIdCol = false;
                let isRefCol = false;
                let typeInput = "input";
                let isTextArea = false;
                let codUniverseTable = "";

                switch (objColumn.column_name) {
                    case "IDPCOCORRENCIA":
                        isIdCol = true;
                        break;
                    case "IDPCOPERACAO":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "operacoes_list";
                        if(value === undefined || value === "") {
                            value = $('#id-civil-protection-operation-type-selected').val();
                            // Set mode readonly for this column
                            if( value !== "")
                            {
                                readOnly = 'readonly';
                            }
                        }
                        break;
                    case "IDPCTIPOOCORRENCIA":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "tipos_list";
                        break;
                    case "IDFREGUESIA":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "freguesia_list";
                        if(featureInfo.mode !== 'read')
                        {
                            var disabled = readOnly == 'readonly' ? 'disabled' : '';
                            var idComboNode = 'prop_assoc_' + objColumn.column_name;
                            // Add select box with associated entity possible values
                            $('#id-offcanvas-body-layer-detail-field').append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="' + idComboNode + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                                + '</div > '
                            ));

                            var coordinatesFeature = featureInfo.feature.getGeometry().getCoordinates();
                            if(typeof coordinatesFeature[0] === "object")
                                coordinatesFeature = coordinatesFeature[0];
                            myCivilProtectionTool._GetFeatureBufferForCombo(coordinatesFeature[0],
                                                                           coordinatesFeature[1],
                                                                           myCivilProtectionTool._radiusSearch,
                                                                           myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesia].geoserver,
                                                                           myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesia].workspace,
                                                                           myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesia].layerName,
                                                                           myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesia].geom_column_name,
                                                                           idComboNode,
                                                                           value);

                            // Event on change "Freguesia"
                            $('#' + idComboNode).off('change.bs.select').on('change.bs.select', function ()
                            {
                                var idFreguesia = $('#prop_assoc_IDFREGUESIA').val();
                                if(myCivilProtectionTool._hashReferenceCombo["section"][idFreguesia])
                                {
                                    comboArray = myCivilProtectionTool._hashReferenceCombo["section"][idFreguesia];
                                    myCivilProtectionTool._utility.FillSelect('prop_assoc_IDFREGUESIATROCO', comboArray, 'value', 'id', true);
                                }
                                else
                                {
                                    // Clean section combo
                                    myCivilProtectionTool._utility.FillSelect('prop_assoc_IDFREGUESIATROCO', [], 'value', 'id', false);

                                    // Clean police combo
                                    myCivilProtectionTool._utility.FillSelect('prop_assoc_NUMEROPOLICIA', [], 'value', 'id', false);
                                }
                            });

                            continue;
                        }
                        break;
                    case "IDTROCO":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "troco_list";
                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        var idComboNode = 'prop_assoc_' + objColumn.column_name;
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="' + idComboNode + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div > '
                        ));

                        var coordinatesFeature = featureInfo.feature.getGeometry().getCoordinates();
                        if(typeof coordinatesFeature[0] === "object")
                            coordinatesFeature = coordinatesFeature[0];
                        myCivilProtectionTool._GetFeatureBufferForCombo(coordinatesFeature[0],
                                                                       coordinatesFeature[1],
                                                                       myCivilProtectionTool._radiusSearch,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesiaSection].geoserver,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesiaSection].workspace,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesiaSection].layerName,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameFreguesiaSection].geom_column_name,
                                                                       idComboNode,
                                                                       value);

                        // Event on change section
                        $('#' + idComboNode).off('change.bs.select').on('change.bs.select', function ()
                        {
                            var sectionFreguesiaArray = myCivilProtectionTool._hashReferenceCombo.section[$("#prop_assoc_IDFREGUESIA").val()];
                            if(sectionFreguesiaArray !== undefined)
                            {
                                var objSection = sectionFreguesiaArray.find(c=> c.id.toString() === $("#prop_assoc_IDTROCO").val());
                                let idSectionValue = (objSection !== undefined)?objSection.id_troco:"";

                                if(myCivilProtectionTool._hashReferenceCombo["section_police"][idSectionValue])
                                {
                                    comboArray = myCivilProtectionTool._hashReferenceCombo["section_police"][idSectionValue];
                                    myCivilProtectionTool._utility.FillSelect('prop_assoc_NUMEROPOLICIA', comboArray, 'value', 'id', true);
                                }
                            }
                            else
                            {
                                // Empty combo police
                                myCivilProtectionTool._utility.FillSelect('prop_assoc_NUMEROPOLICIA', [], 'value', 'id', false);
                            }
                        });

                        continue;
                        break;
                    case "NUMEROPOLICIA":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "npolicia_list";
                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        var idComboNode = 'prop_assoc_' + objColumn.column_name;
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="' + idComboNode + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div > '
                        ));

                        var coordinatesFeature = featureInfo.feature.getGeometry().getCoordinates();
                        if(typeof coordinatesFeature[0] === "object")
                            coordinatesFeature = coordinatesFeature[0];
                        myCivilProtectionTool._GetFeatureBufferForCombo(coordinatesFeature[0],
                                                                       coordinatesFeature[1],
                                                                       myCivilProtectionTool._radiusSearch,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameSectionPolice].geoserver,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameSectionPolice].workspace,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameSectionPolice].layerName,
                                                                       myCivilProtectionTool._layerInformation[myCivilProtectionTool._layerInformationFillField.layerNameSectionPolice].geom_column_name,
                                                                       idComboNode,
                                                                       value);
                        continue;
                        break;
                    case "IDPCOCORRENCIAESTADO":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "estados_list";
                        break;
                    case "IDPCFONTE":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "fontes_list";
                        break;
                    case "VISITAREPRESENTANTE":
                        isRefCol = true;
                        typeInput = "combo";
                        codUniverseTable = "representante_list";
                        break;
                    case "OBSERVACOES":
                        isTextArea = true;
                        typeInput = "text_area";
                        break;
                    default:
                        break;
                };

                if (isIdCol) {
                    hiddenCol = true;
                } else if (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'DATA') {
                    hiddenCol = true; // Hide column DATA for PONTA DELGADA creations
                    value = myCivilProtectionTool._utility.getNewDateForServer();
                } else {
                    hiddenCol = false;
                }

                if (value === null || value === undefined)
                    value = '';

                // Act according column type
                switch (objColumn.column_type) {
                    case "xsd:date-time":
                        value = myCivilProtectionTool._utility.TransformDateServerInDateII(value);
                        break;
                    default:
                    // do nothing
                }

                var comboArray = [];
                var prefix = "id_";
                if (isRefCol) {
                    comboArray = myCivilProtectionTool._hashReference[codUniverseTable];
                    prefix = "";
                }

                // Check if there is an associated field with a id_ prefix to add combo boxes
                switch(typeInput)
                {
                    case "combo":
                        var defValue = "";

                        if (objColumn.column_name == "IDPCOCORRENCIAESTADO")
                        {
                            switch (layerPrettyName) {
                                case "Abertas":
                                    value = "Aberta";
                                    break;
                                case "Fechadas":
                                    value = "Fechada";
                                    break;
                                default:
                                    value = "Aberta sem localização confirmada";
                            };
                        }

                        if (value != "")
                        {
                            if (typeof comboArray == "undefined" && objColumn.column_name === "IDTROCO") {
                                comboArray = myCivilProtectionTool._hashReference["trocos_list"];
                            }

                            if (comboArray.length > 0)
                            {
                                if (objColumn.column_name == "IDPCOCORRENCIAESTADO") {
                                    defValue = comboArray.filter(function (ob) { return ob.value == value; })[0]
                                } else {
                                    defValue = comboArray.filter(function (ob) { return ob.id == value; })[0]
                                }

                                if (featureInfo.mode == 'read') {
                                    defValue = defValue.value;
                                } else {
                                    defValue = defValue.id;
                                }
                            }
                        }

                        // Fill rule for field
                        switch (objColumn.column_name) {
                            case "IDFREGUESIA":
                                var featureFreguesia = myCivilProtectionTool._GetFreguesiaInfoFromPoint(myCivilProtectionTool._featureInfo.feature);
                                if (featureFreguesia !== null)
                                    defValue = featureFreguesia.getProperties().IDFREGUESIA;
                                break;
                            case "IDPCOPERACAO":
                                // If mode create then only open operation
                                if(featureInfo.mode === 'create')
                                {
                                    comboArray = comboArray.filter(c=> c.state === myCivilProtectionTool._valueOpenOperation);
                                }
                                break;
                            default:
                                break;
                        }

                        // In read mode, add text box for ID_REF
                        if (featureInfo.mode == 'read') {

                            $('#id-offcanvas-body-layer-detail-field').append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                                + '</div > '
                            ));

                        } else {

                            var disabled = readOnly == 'readonly' ? 'disabled' : '';
                            // Add select box with associated entity possible values
                            $('#id-offcanvas-body-layer-detail-field').append($(
                                '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                                + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="prop_assoc_' + objColumn.column_name + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                                + '</div > '
                            ));

                            myCivilProtectionTool._utility.FillSelect("prop_assoc_" + objColumn.column_name, comboArray, 'value', 'id');

                            $('#' + 'prop_assoc_' + objColumn.column_name).selectpicker('val', defValue);

                            // Add field that contains ID for associated entity
                            $('#id-offcanvas-body-layer-detail-field').append($(
                                '<div class="form-group offcanvas-body-layer-detail-row hidden">'
                                + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                                + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" placeholder="' + objColumn.pretty_name + '" ' + readOnly + '/>'
                                + '</div > '
                            ));
                        }
                        break;
                    case "text_area":
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<textarea rows="3" class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '"  id="prop_' + objColumn.column_name + '" placeholder="' + objColumn.pretty_name + '" ' + readOnly + '>' + value + '</textarea>'
                            + '</div > '
                        ));
                        break;
                    case "input":
                        let type = "text";

                        if (objColumn.column_type == "xsd:date")
                        {
                            type = "date";
                            if(value !== "")
                            {
                                var valueDate = new Date(value);
                                value = valueDate.getFullYear() + "-" + (valueDate.getMonth() + 1).toString().padStart(2, "0") + "-" + valueDate.getDate().toString().padStart(2, "0");
                            }
                        }

                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="' + type + '" id="prop_' + objColumn.column_name + '" value="' + value + '" placeholder="' + objColumn.pretty_name + '" ' + readOnly + '/>'
                            + '</div > '
                        ));
                        break;
                    default:
                        // do nothing
                };
            }
        };

        let container = $('#id-offcanvas-layer-detail .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12');

        // -- Dados Estatísticos -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-dados-estatisticos').remove();

        let mortaisValue = featureInfo.feature.getProperties()["NUMEROVITIMASMORTAIS"];
        let gravesValue = featureInfo.feature.getProperties()["NUMEROVITIMASESTADOGRAVE"];
        let ligeirasValue = featureInfo.feature.getProperties()["NUMEROVITIMASLIGEIRAS"];
        let danificadasValue = featureInfo.feature.getProperties()["NUMEROHABITACOESDANIFICADAS"];
        let desalojadosValue = featureInfo.feature.getProperties()["NUMERODESALOJADOS"];
        let viaturasValue = featureInfo.feature.getProperties()["NUMEROVIATURASATINGIDAS"];
        let viasValue = featureInfo.feature.getProperties()["NUMEROVIASOBSTRUIDAS"];
        let obsDadosValue = featureInfo.feature.getProperties()["OBSERVACOESDADOSESTATISTICOS"];

        if (mortaisValue === null || mortaisValue === undefined || mortaisValue === '')
            mortaisValue = 0;

        if (gravesValue === null || gravesValue === undefined || gravesValue === '')
            gravesValue = 0;

        if (ligeirasValue === null || ligeirasValue === undefined || ligeirasValue === '')
            ligeirasValue = 0;

        let totalVitimasValue = +mortaisValue + +gravesValue + +ligeirasValue;

        if (danificadasValue === null || danificadasValue === undefined || danificadasValue === '')
            danificadasValue = 0;

        if (desalojadosValue === null || desalojadosValue === undefined || desalojadosValue === '')
            desalojadosValue = 0;

        if (viaturasValue === null || viaturasValue === undefined || viaturasValue === '')
            viaturasValue = 0;

        if (viasValue === null || viasValue === undefined || viasValue === '')
            viasValue = 0;

        if (obsDadosValue === null || obsDadosValue === undefined)
            obsDadosValue = '';

        let dadosContent =
            '<div id="id-offcanvas-body-layer-detail-dados-estatisticos" class="offcanvas-block" style="display: none;">'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMEROVITIMASMORTAIS">Número de vítimas mortais</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMEROVITIMASMORTAIS" type="number" min="0" value="${mortaisValue}">`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMEROVITIMASESTADOGRAVE">Número de vítimas em estado grave</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMEROVITIMASESTADOGRAVE" type="number" min="0" value="${gravesValue}">`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMEROVITIMASLIGEIRAS">Número de vítimas ligeiras</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMEROVITIMASLIGEIRAS" type="number" min="0" value="${ligeirasValue}">`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMEROVITIMASTOTAL">Número de vítimas total</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMEROVITIMASTOTAL" type="number" value="${totalVitimasValue}" readonly>`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMEROHABITACOESDANIFICADAS">Número de habitações danificadas</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMEROHABITACOESDANIFICADAS" type="number" min="0" value="${danificadasValue}">`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMERODESALOJADOS">Número de desalojados</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMERODESALOJADOS" type="number" min="0" value="${desalojadosValue}">`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMEROVIATURASATINGIDAS">Número de viaturas atingidas</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMEROVIATURASATINGIDAS" type="number" min="0" value="${viaturasValue}">`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_NUMEROVIASOBSTRUIDAS">Número de vias obstruídas</label>'
            + `<input class="feature-field form-control xsd:string" id="prop_NUMEROVIASOBSTRUIDAS" type="number" min="0" value="${viasValue}">`
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_OBSERVACOESDADOSESTATISTICOS">Observações</label>'
            + `<textarea class="feature-field form-control xsd:string" id="prop_OBSERVACOESDADOSESTATISTICOS" rows="3" placeholder="Observações">${obsDadosValue}</textarea>`
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-dados-estatisticos" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-dados-estatisticos" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Dados Estatísticos</label>'
            + '</div>'
            + dadosContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        // Count total victims
        $('#prop_NUMEROVITIMASMORTAIS, #prop_NUMEROVITIMASESTADOGRAVE, #prop_NUMEROVITIMASLIGEIRAS').off('keyup mouseup').on('keyup mouseup', function () {
            var mortaisVal = $('#prop_NUMEROVITIMASMORTAIS').val();
            var graveVal = $('#prop_NUMEROVITIMASESTADOGRAVE').val();
            var ligeirasVal = $('#prop_NUMEROVITIMASLIGEIRAS').val();

            var total = +mortaisVal + +graveVal + +ligeirasVal;

            $('#prop_NUMEROVITIMASTOTAL').val(total);
        });

        // -- Entidades Presentes -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-entidades-presentes').remove();
        myCivilProtectionTool._entidadesPresentesRowCounter = 0;

        let obsEntidadesValue = featureInfo.feature.getProperties()["OBSERVACOESENTIDADESPRESENTES"];

        if (obsEntidadesValue === null || obsEntidadesValue === undefined)
            obsEntidadesValue = '';

        let entidadesContent = '<div id="id-offcanvas-body-layer-detail-entidades-presentes" class="offcanvas-block" style="display: none;">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-entidades-presentes-btn-add-entidade" style="margin-bottom: 5px;" title="Inserir endidade"><i class="fa fa-plus"></i></button>'
            + '<div id="prop_entidades-presentes_add_entidade_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_entidades-presentes_add_entidade" style="font-weight:100;">Entidade</label>'
            + '<select title="Nenhum escolhido" class="feature-field form-control xsd:string" id="prop_entidades-presentes_add_entidade"><option></option></select>'
            + '</div>'
            + '<div id="prop_entidades-presentes_add_buttons_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-entidades-presentes-btn-add-entidade-close" style="margin: 0 2px;" title="Cancelar Entidade"><i class="fa fa-times"></i></button>'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-entidades-presentes-btn-add-entidade-add" style="margin: 0 2px;" title="Adicionar Entidade"><i class="fa fa-share"></i></button>'
            + '</div>'
            + '<div class="table-responsive">'
            + '<table id="id-entidades-presentes-table" class="table table-civil-protection-add-entity" table-hover>'
            + '<thead><tr><th scope="col" class="description">Entidade</th></tr></thead>'
            + '<tbody id="id-offcanvas-body-layer-detail-entidades-presentes-table-body">'
            + '</tbody>'
            + '</table>'
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_OBSERVACOESENTIDADESPRESENTES">Observações</label>'
            + `<textarea class="feature-field form-control xsd:string" id="prop_OBSERVACOESENTIDADESPRESENTES" rows="3" placeholder="Observações">${obsEntidadesValue}</textarea>`
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-entidades-presentes" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-entidades-presentes" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Entidades Presentes</label>'
            + '</div>'
            + entidadesContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        //myCivilProtectionTool._utility.FillSelect("prop_entidades-presentes_add_entidade", myCivilProtectionTool._hashReference['entidades_list'], 'value', 'id');

        // Add Entidade click
        $('#id-offcanvas-body-layer-detail-entidades-presentes-btn-add-entidade').off('click').on('click', function () {
            $("#prop_entidades-presentes_add_entidade_div").removeClass("hidden");
            $("#prop_entidades-presentes_add_buttons_div").removeClass("hidden");
        });

        // Close Add Entidade click
        $('#id-offcanvas-body-layer-detail-entidades-presentes-btn-add-entidade-close').off('click').on('click', function () {
            $("#prop_entidades-presentes_add_entidade_div").addClass("hidden");
            $("#prop_entidades-presentes_add_entidade").val("")
            $("#prop_entidades-presentes_add_buttons_div").addClass("hidden");
        });

        // Confirm Add Entidade click
        $('#id-offcanvas-body-layer-detail-entidades-presentes-btn-add-entidade-add').off('click').on('click', function () {
            let entidadeValue = $("#prop_entidades-presentes_add_entidade option:selected").text();
            let entidadeId = $("#prop_entidades-presentes_add_entidade").val();

            if (entidadeId === "") {
                $("#id-offcanvas-body-layer-detail-entidades-presentes-btn-add-entidade-close").click();
                return;
            }

            if( entidadeId === $('#id-meios-envolvidos-table tr td.id-entity').html())
            {
                toastr["warning"]('Entidade já seleccionada');
                return;
            }

            if (entidadeValue == "Nenhum escolhido")
                entidadeValue = "";

            myCivilProtectionTool._entidadesPresentesRowCounter++;
            var rowId = myCivilProtectionTool._entidadesPresentesRowCounter;
            var trId = `id-row-entity-${rowId}`;
            var anchorId = `id-anchor-entity-${rowId}`;

            let newContent = `<tr id="${trId}"><td class="hidden">${rowId}</td><td class="description">${entidadeValue}</td><td class="hidden id-entity">${entidadeId}</td><td><i><a id="${anchorId}" href="#" title="Remoção"><i class="material-icons">delete</i></a></i></td></tr>`;

            myCivilProtectionTool._hashReference['entidades_presentes_list'].push({ "id": rowId, "entidade": entidadeId });

            let tableBody = $("#id-offcanvas-body-layer-detail-entidades-presentes-table-body");
            tableBody.append(newContent);

            $("#prop_entidades-presentes_add_entidade_div").addClass("hidden");
            $("#prop_entidades-presentes_add_entidade").val("");
            $("#prop_entidades-presentes_add_buttons_div").addClass("hidden");

            $(`#${anchorId}`).off('click').on('click', function () {
                let arrayId = trId.split('-')[2];

                $(`#${trId}`).remove();

                myCivilProtectionTool._hashReference['entidades_presentes_list'] = myCivilProtectionTool._hashReference['entidades_presentes_list'].filter(function (element) {
                    return element.id != arrayId;
                });
            });
        });

        // -- Meios Envolvidos -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-meios-envolvidos').remove();
        myCivilProtectionTool._meiosEnvolvidosRowCounter = 0;

        let obsMeiosValue = featureInfo.feature.getProperties()["OBSERVACOESMEIOS"];

        if (obsMeiosValue === null || obsMeiosValue === undefined)
            obsMeiosValue = '';

        let meiosContent = '<div id="id-offcanvas-body-layer-detail-meios-envolvidos" class="offcanvas-block" style="display: none;">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-meios-envolvidos-btn-add-meio" style="margin-bottom: 5px;" title="Inserir Meio"><i class="fa fa-plus"></i></button>'
            + '<div id="prop_meios-envolvidos_add_meio_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_meios-envolvidos_add_meio" style="font-weight:100;">Meio</label>'
            + '<select title="Nenhum escolhido" class="feature-field form-control xsd:string" id="prop_meios-envolvidos_add_meio"><option></option></select>'
            + '</div>'
            + '<div id="prop_meios-envolvidos_add_buttons_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-meios-envolvidos-btn-add-meio-close" style="margin: 0 2px;" title="Cancelar Meio"><i class="fa fa-times"></i></button>'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-meios-envolvidos-btn-add-meio-add" style="margin: 0 2px;" title="Adicionar Meio"><i class="fa fa-share"></i></button>'
            + '</div>'
            + '<div class="table-responsive">'
            + '<table id="id-meios-envolvidos-table" class="table table-civil-protection-means" table-hover>'
            + '<thead><tr><th scope="col" class="description">Meio</th></tr></thead>'
            + '<tbody id="id-offcanvas-body-layer-detail-meios-envolvidos-table-body">'
            + '</tbody>'
            + '</table>'
            + '</div>'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_OBSERVACOESMEIOS">Observações</label>'
            + `<textarea class="feature-field form-control xsd:string" id="prop_OBSERVACOESMEIOS" rows="3" placeholder="Observações">${obsMeiosValue}</textarea>`
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-meios-envolvidos" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-meios-envolvidos" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Meios Envolvidos</label>'
            + '</div>'
            + meiosContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        myCivilProtectionTool._utility.FillSelect("prop_meios-envolvidos_add_meio", myCivilProtectionTool._hashReference['meios_list'], 'value', 'id');

        // Add Meio click
        $('#id-offcanvas-body-layer-detail-meios-envolvidos-btn-add-meio').off('click').on('click', function () {
            $("#prop_meios-envolvidos_add_meio_div").removeClass("hidden");
            $("#prop_meios-envolvidos_add_buttons_div").removeClass("hidden");
        });

        // Close Add Meio click
        $('#id-offcanvas-body-layer-detail-meios-envolvidos-btn-add-meio-close').off('click').on('click', function () {
            $("#prop_meios-envolvidos_add_meio_div").addClass("hidden");
            $("#prop_meios-envolvidos_add_meio").val("");
            $("#prop_meios-envolvidos_add_buttons_div").addClass("hidden");
        });

        // Confirm Add Meio click
        $('#id-offcanvas-body-layer-detail-meios-envolvidos-btn-add-meio-add').off('click').on('click', function ()
        {
            let meanDescription = $("#prop_meios-envolvidos_add_meio option:selected").text();
            let idMean = $("#prop_meios-envolvidos_add_meio").val();

            myCivilProtectionTool._AddMeanToOccurrence(idMean, meanDescription);
        });

        // Fill means from dataase
        if(featureInfo.mode != "create")
        {
            $.ajax({
                type: 'GET',
                url: '/rest/app/CivilProtectionTool/GetOccurrenceMeans?idOccurrence=' + featureInfo.feature.getProperties().IDPCOCORRENCIA,
                async: true,
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na obtenção da informação dos meios da ocorrência");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var listOccurrenceMeans = data.result.listOccurrenceMeans;
                                if (listOccurrenceMeans.length > 0) {
                                    for (let i = 0; i < listOccurrenceMeans.length; i++) {
                                        var objMean = listOccurrenceMeans[i];
                                        myCivilProtectionTool._AddMeanToOccurrence(objMean.id, objMean.value);
                                    }
                                }
                                break;
                            case 'ERROR':
                                toastr["error"]("Erro na obtenção da informação dos meios da ocorrência");
                                break;
                            default:
                        }
                    }

                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na obtenção da informação dos meios da ocorrência");
                }
            });
        }

        // -- Notas -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-notas').remove();
        myCivilProtectionTool._notasRowCounter = 0;
        
        let notasContent = '<div id="id-offcanvas-body-layer-detail-notas" class="offcanvas-block" style="display: none;">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-notas-btn-add-nota" style="margin-bottom: 5px;" title="Inserir Nota"><i class="fa fa-plus"></i></button>'
            + '<div id="prop_notas_add_data_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_notas_add_data" style="font-weight:100;">Data</label>'
            + '<input class="feature-field form-control" id="prop_notas_add_data" type="datetime-local" value="">'
            + '</div>'
            + '<div id="prop_notas_add_nota_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_notas_add_nota" style="font-weight:100;">Nota</label>'
            + '<textarea class="feature-field form-control xsd:string" id="prop_notas_add_nota" rows="2" value=""></textarea>'
            + '</div>'
            + '<div id="prop_notas_add_buttons_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-notas-btn-add-nota-close" style="margin: 0 2px;" title="Cancelar nota"><i class="fa fa-times"></i></button>'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-notas-btn-add-nota-add" style="margin: 0 2px;" title="Adicionar nota"><i class="fa fa-share"></i></button>'
            + '</div>'
            + '<div class="table-responsive">'
            + '<table id="id-notas-table" class="table table-civil-protection-note" table-hover>'
            + '<thead><tr><th scope="col" class="data">Data</th><th scope="col" class="description">Nota</th></tr></thead>'
            + '<tbody id="id-offcanvas-body-layer-detail-notas-table-body">'
            + '</tbody>'
            + '</table>'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-notas" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-notas" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Notas</label>'
            + '</div>'
            + notasContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        // Add nota click
        $('#id-offcanvas-body-layer-detail-notas-btn-add-nota').off('click').on('click', function () {
            $("#prop_notas_add_data_div").removeClass("hidden");
            $("#prop_notas_add_nota_div").removeClass("hidden");
            $("#prop_notas_add_buttons_div").removeClass("hidden");
        });

        // Close Add nota click
        $('#id-offcanvas-body-layer-detail-notas-btn-add-nota-close').off('click').on('click', function () {
            $("#prop_notas_add_data_div").addClass("hidden");
            $("#prop_notas_add_data").val("")
            $("#prop_notas_add_nota_div").addClass("hidden");
            $("#prop_notas_add_nota").val("")
            $("#prop_notas_add_buttons_div").addClass("hidden");
        });

        // Confirm Add Nota click
        $('#id-offcanvas-body-layer-detail-notas-btn-add-nota-add').off('click').on('click', function () {
            let dateValue = $("#prop_notas_add_data").val();
            let noteValue = $("#prop_notas_add_nota").val();

            myCivilProtectionTool._AddNoteToOccurrence(noteValue, dateValue);
        });

        // Add values and behaviours to combo boxes
        $('select.feature-field').each(function () {
            var comboBox = $(this);
            var destinationText = comboBox.data('destination-field');
            comboBox.on('change', function () {
                // Update respective id field for db update
                $('#' + destinationText).val($(this).val());
            });
        });

        // Refresh collapse elements
        $('.offcanvas-collapse').off('click').on('click', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            // Close all other info

            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        // Fill means from dataase
        if(featureInfo.mode != "create")
        {
            $.ajax({
                type: 'GET',
                url: '/rest/app/CivilProtectionTool/GetOccurrenceNote?idOccurrence=' + featureInfo.feature.getProperties().IDPCOCORRENCIA,
                async: true,
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na obtenção da informação das notas da ocorrência");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var listOccurrenceNote = data.result.listOccurrenceNote;
                                if (listOccurrenceNote.length > 0) {
                                    for (let i = 0; i < listOccurrenceNote.length; i++) {
                                        var objNote = listOccurrenceNote[i];
                                        myCivilProtectionTool._AddNoteToOccurrence(objNote.nota, objNote.data);
                                    }
                                }
                                break;
                            case 'ERROR':
                                toastr["error"]("Erro na obtenção da informação das notas da ocorrência");
                                break;
                            default:
                        }
                    }

                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na obtenção da informação das notas da ocorrência");
                }
            });
        }

        // -- File --------------------------------------------------------------------------------

        // Init Upload for entity
        if (myCivilProtectionTool._mapSgs._uploadAttachtment)
            myCivilProtectionTool._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-offcanvas-body-layer-detail-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-body-layer-detail-attachment-spinner');

        // Event on chanfe freguesia
        $('#prop_assoc_IDFREGUESIA').on('changed.bs.select', function () {
            $("#prop_assoc_IDTROCO").empty();

            let selectedValue = this.value;

            let freguesiaTrocoList = myCivilProtectionTool._hashReference['freguesia_troco_list'];

            let filteredFreguesiaTroco = freguesiaTrocoList.filter(function (el) {
                return el.idFreguesia === selectedValue;
            });

            let idTrocos = filteredFreguesiaTroco.map(x => x.idTroco);

            let trocosList = myCivilProtectionTool._hashReference['trocos_list'];

            let filteredTrocos = [];

            idTrocos.forEach(x => {

                let troco = trocosList.filter(function (el) {
                    return el.id === x;
                });

                if (troco.length > 0)
                    filteredTrocos.push({ "id": troco[0].id, "value": troco[0].value });
            });

            myCivilProtectionTool._utility.FillSelect("prop_assoc_IDTROCO", filteredTrocos, 'value', 'id');
        });

        // Stop wait
        myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
    };

    /**
     * Clean detail
     */
    this.CleanDetail = function ()
    {
        // -- Dados Estatísticos -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-dados-estatisticos').remove();
        // -- Entidades Presentes -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-entidades-presentes').remove();
        // -- Meios Envolvidos -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-meios-envolvidos').remove();
        // -- Notas -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-notas').remove();
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Delete occurrence
     * @param {int} idOccurrence, occurrence identifier
     */
    this.DeleteOccurrence = function(idOccurrence)
    {
        myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $.ajax({
            type: 'GET',
            url: '/rest/app/CivilProtectionTool/GetDeleteOccurrence?idOccurrence=' + idOccurrence,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na remoção da ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Refresh layer civil protrection layer
                            myCivilProtectionTool._RefreshLayerCivilProtection();

                            // Close offcanvas
                            $('#id-offcanvas-layer-detail .link-default').trigger('click');

                            // Close edition
                            myCivilProtectionTool._mapSgs.layerTree.CloseEdition(false);

                            toastr["success"]("Ocorrência removida com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na remoção da ocorrência");
                    }
                }

                myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção da ocorrência");
                myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Compare
     */
    this._Compare = function (a, b) {
        const posA = a.column_pos;
        const posB = b.column_pos;

        let comparison = 0;
        if (posA > posB) {
            comparison = 1;
        } else if (posA < posB) {
            comparison = -1;
        }

        return comparison;
    };

    /**
    * Get all references for green area tool
    * @param{string} queryTypeOperation, operation type query
    */
    this._GetAllReferences = function (queryTypeOperation) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/CivilProtectionTool/GetAllReference?queryTypeOperation=' + queryTypeOperation,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myCivilProtectionTool._hashReference['estados_list'] = data.result.list_estados;
                            myCivilProtectionTool._hashReference['operacoes_list'] = data.result.list_operacoes;
                            myCivilProtectionTool._hashReference['tipos_list'] = data.result.list_tipos;
                            myCivilProtectionTool._hashReference['fontes_list'] = data.result.list_fontes;
                            myCivilProtectionTool._hashReference['entidades_list'] = data.result.list_entidades;
                            myCivilProtectionTool._hashReference['meios_list'] = data.result.list_meios;
                            myCivilProtectionTool._hashReference['freguesia_troco_list'] = data.result.list_freguesia_troco;
                            myCivilProtectionTool._hashReference['trocos_list'] = data.result.list_trocos;

                            myCivilProtectionTool._utility.FillSelect('id-civilProtectionToolEstado', data.result.list_estados, 'value', 'id', true);
                            myCivilProtectionTool._utility.FillSelect('id-civilProtectionToolOperacao', data.result.list_operacoes, 'value', 'id', true);
                            myCivilProtectionTool._utility.FillSelect('id-civilProtectionToolTipo', data.result.list_tipos, 'value', 'id', true);
                            myCivilProtectionTool._utility.FillSelect('id-civilProtectionToolFonte', data.result.list_fontes, 'value', 'id', true);

                            // Fill operation list for selection
                            myCivilProtectionTool._FillOperationListForSelection();
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });

        myCivilProtectionTool._hashReference['representante_list'] = [
            { "id": "N", "value": "Não" },
            { "id": "Y", "value": "Sim" }
        ];

        myCivilProtectionTool._hashReference['freguesia_list'] = [];

        if (myCivilProtectionTool._mapSgs._hashReference['freguesia'] === undefined) {
            myCivilProtectionTool._mapSgs._GetAllReference();
        };

        myCivilProtectionTool._utility.FillSelect('id-civilProtectionToolVisitaRepresentante', myCivilProtectionTool._hashReference['representante_list'], 'value', 'id', true);
    };

    /**
     * Save civil protection occurrence
     * @param {string} mode, write mode
     * @param {string} saveGeom, save geometry boolean
     */
    this._SaveFeature = function (mode, saveGeom)
    {
        myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        let idPcOcorrenciaValue = $("#prop_IDPCOCORRENCIA").val();
        let idOperacaoValue = $("#prop_IDPCOPERACAO").val();
        let idEstadoValue = $("#prop_IDPCOCORRENCIAESTADO").val();
        let numeroValue = $("#prop_NUMERO").val();
        let idTipoOcorrenciaValue = $("#prop_IDPCTIPOOCORRENCIA").val();
        let dataAberturaValue = $("#prop_DATAABERTURA").val();
        let dataFechoValue = $("#prop_DATAFECHO").val();
        let visitaRepresentanteValue = $("#prop_VISITAREPRESENTANTE").val();
        let idFreguesiaValue = $("#prop_assoc_IDFREGUESIA").val();
        let idTrocoValue = "";
        var sectionFreguesiaArray = myCivilProtectionTool._hashReferenceCombo.section[$("#prop_assoc_IDFREGUESIA").val()];
        if(sectionFreguesiaArray !== undefined)
        {
            var objSection = sectionFreguesiaArray.find(c=> c.id.toString() === $("#prop_assoc_IDTROCO").val());
            idTrocoValue = (objSection !== undefined)?objSection.id_troco:"";
        }
        let numeroPoliciaValue = $('#prop_assoc_NUMEROPOLICIA').find("option:selected").text();
        let idFonteValue = $("#prop_IDPCFONTE").val();
        let contatoNomeValue = $("#prop_CONTACTONOME").val();
        let contatoTelefoneValue = $("#prop_CONTACTOTELEFONE").val();
        let observacoesValue = $("#prop_OBSERVACOES").val();

        let vitimasMortaisValue = $("#prop_NUMEROVITIMASMORTAIS").val();
        let vitimasGravesValue = $("#prop_NUMEROVITIMASESTADOGRAVE").val();
        let vitimasLigeirasValue = $("#prop_NUMEROVITIMASLIGEIRAS").val();
        let habitacoesDanificadasValue = $("#prop_NUMEROHABITACOESDANIFICADAS").val();
        let desalojadosValue = $("#prop_NUMERODESALOJADOS").val();
        let viaturasAtingidasValue = $("#prop_NUMEROVIATURASATINGIDAS").val();
        let viasObstruidasValue = $("#prop_NUMEROVIASOBSTRUIDAS").val();
        let observacoesDadosValue = $("#prop_OBSERVACOESDADOSESTATISTICOS").val();

        let entidadesPresentes = myCivilProtectionTool._hashReference['entidades_presentes_list'];
        let observacoesEntidadesValue = $("#prop_OBSERVACOESENTIDADESPRESENTES").val();

        let meiosEnvolvidos = myCivilProtectionTool._hashReference['meios_envolvidos_list'];
        let observacoesMeiosValue = $("#prop_OBSERVACOESMEIOS").val();

        let notas = myCivilProtectionTool._hashReference['notas_list'];

        let geom_wkt = "";
        let geom_srid = "";
        if(saveGeom)
        {
            geom_wkt = new WKT().writeGeometry(myCivilProtectionTool._featureInfo.feature.getGeometry());
            geom_srid = myCivilProtectionTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        }

        let civilProtectionOccurrenceSaveFields = {
            idPcOcorrencia: idPcOcorrenciaValue,
            idOperacao: idOperacaoValue,
            idEstado: idEstadoValue,
            numero: numeroValue,
            idTipoOcorrencia: idTipoOcorrenciaValue,
            dataAbertura: dataAberturaValue,
            dataFecho: dataFechoValue,
            visitaRepresentante: visitaRepresentanteValue,
            idFreguesia: idFreguesiaValue,
            idTroco: idTrocoValue,
            numeroPolicia: numeroPoliciaValue,
            idFonte: idFonteValue,
            contatoNome: contatoNomeValue,
            contatoTelefone: contatoTelefoneValue,
            observacoes: observacoesValue,
            vitimasMortais: vitimasMortaisValue,
            vitimasGraves: vitimasGravesValue,
            vitimasLigeiras: vitimasLigeirasValue,
            habitacoesDanificadas: habitacoesDanificadasValue,
            desalojados: desalojadosValue,
            viaturasAtingidas: viaturasAtingidasValue,
            viasObstruidas: viasObstruidasValue,
            observacoesDados: observacoesDadosValue,
            entidadesPresentes: entidadesPresentes,
            observacoesEntidades: observacoesEntidadesValue,
            meiosEnvolvidos: meiosEnvolvidos,
            observacoesMeios: observacoesMeiosValue,
            notas: notas,
            geom_wkt: geom_wkt,
            geom_srid: geom_srid,
            saveGeom: saveGeom,
            mode: mode,
            userName: myCivilProtectionTool._mapSgs._settings._mapSettings.user_info.user_name
        };

        $.ajax({
            type: 'POST',
            url: '/rest/app/CivilProtectionTool/SaveOccurrence',
            data: JSON.stringify(civilProtectionOccurrenceSaveFields),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação da ocorrência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Refresh layer civil protrection layer
                            myCivilProtectionTool._RefreshLayerCivilProtection();

                            // Close edition
                            myCivilProtectionTool._mapSgs.layerTree.CloseEdition(false);

                            toastr["success"]("Ocorrência criada com sucesso");
                            myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                            break;
                        default:
                            toastr["error"]("Erro na criação da ocorrência");
                            myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação da ocorrência");
                myCivilProtectionTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    };

    /**
     * Get Freguesia Info from point
     */
    this._GetFreguesiaInfoFromPoint = function (featurePoint) {
        var featureReturn = null;

        // Get point geojson
        var pointCoord = null;
        if (featurePoint.getGeometry().getCoordinates()[0] instanceof Array)
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates()[0]);
        else
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates());

        myCivilProtectionTool.collectionFeatureSet.getArray().forEach(function (featureIn, index) {
            if (featureIn.getId().indexOf("FREGUESIA") >= 0) {
                var featureInGeoJson = myCivilProtectionTool._geojsonFormat.writeFeatureObject(featureIn);
                if (turf.booleanPointInPolygon(pointCoord, featureInGeoJson)) {
                    // Get feature freguesia info
                    featureReturn = featureIn;
                }
            }
        });

        return featureReturn;
    };

    /**
     * Search civil protection occurrences
     */
    this._SearchCivilProtectionOccurrences = function () {
        myCivilProtectionTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Build Filter
        var cqlFilter = "";
        var numero = $('#id-civilProtectionToolNumero').val();
        var freguesia = $('#id-civilProtectionToolFreguesia').val();
        var estado = $('#id-civilProtectionToolEstado').val();
        var operacao = $('#id-civilProtectionToolOperacao').val();
        var tipo = $('#id-civilProtectionToolTipo').val();
        var fonte = $('#id-civilProtectionToolFonte').val();

        if (numero !== "") {
            var query = `NUMERO = '${numero}'`;
            cqlFilter = query;
        }

        if (freguesia !== "") {
            var query = `IDFREGUESIA = ${freguesia}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (estado !== "") {
            var query = `IDPCOCORRENCIAESTADO = ${estado}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (operacao !== "") {
            var query = `IDPCOPERACAO = ${operacao}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (tipo !== "") {
            var query = `IDPCTIPOOCORRENCIA = ${tipo}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (fonte !== "") {
            var query = `IDPCFONTE = ${fonte}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        // Get features
        var layerName = myCivilProtectionTool._LayerCivilProtectionName;
        var layerInfo = myCivilProtectionTool._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterResult = cqlFilter;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    if (myCivilProtectionTool._mapSgs.featureToHighLight.getLength() > 0)
                        myCivilProtectionTool._mapSgs.featureToHighLight.clear();

                    myCivilProtectionTool._mapSgs._arraySearchLayerFeatureActive = [];

                    var feature = null;
                    var layerName = myCivilProtectionTool._LayerCivilProtectionName;
                    var idLayer = myCivilProtectionTool._mapSgs.layerTree.FindLayerInfo(layerName).id;
                    var workspace = myCivilProtectionTool._mapSgs.layerTree.FindLayerInfo(layerName).workspace;

                    var columnDefArray = [];
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnValueArray = [];
                    var idPrimaryKey = null;
                    var featureHash = {};

                    for (let i = 0; i < data.features.length; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];
                        idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature Search
                        myCivilProtectionTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                            var columnName = Object.keys(feature.getProperties())[j];

                            if (columnName === "geometry")
                                continue;

                            var value = feature.getProperties()[columnName];
                            var columnProperties = myCivilProtectionTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myCivilProtectionTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (i === 0) {
                                    var columnSearchResult = myCivilProtectionTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myCivilProtectionTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myCivilProtectionTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myCivilProtectionTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px',
                                            'search_order': searchResultOrder
                                        });
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);

                        // Put in feature highlight
                        myCivilProtectionTool._mapSgs.featureToHighLight.push(feature);
                        var styleElement = myCivilProtectionTool._mapSgs._defaultHighlighStyles;
                        myCivilProtectionTool._mapSgs.featureToHighLight.getArray()[myCivilProtectionTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }

                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Show canvas search result
                    myCivilProtectionTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myCivilProtectionTool._mapSgs.InitSearchResultTable(workspace, layerName, idLayer, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myCivilProtectionTool.DetailElement);

                    // Go to Feature
                    myCivilProtectionTool._mapSgs.map.getView().fit(myCivilProtectionTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myCivilProtectionTool._mapSgs.map.getSize() });

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
                }
                else {
                    toastr["warning"]("Não foi encontrada, nenhuma camada");
                }
            };

            // Stop wait
            myCivilProtectionTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };

    /**
     * Refresh civil protection layer
     */
    this._RefreshLayerCivilProtection = function()
    {
        // Refresh all route layer
        var arraylayerInfo = myCivilProtectionTool._mapSgs.layerTree.FindAllLayerInfo(myCivilProtectionTool._LayerCivilProtectionName);
        for(var i = 0; i < arraylayerInfo.length; i++)
        {
            var layer = myCivilProtectionTool._mapSgs._utility.GetLayerByName(myCivilProtectionTool._mapSgs.map, arraylayerInfo[i].layerNameKey);
            layer.getSource().clear();
        }
    }

    /**
     * Add a mean to a occurrence
     * @param {int} idMean, mean identifier
     * @param {string} meanDescription, mean desciption
     */
    this._AddMeanToOccurrence = function(idMean, meanDescription)
    {
        if (idMean === "") {
            $("#id-offcanvas-body-layer-detail-meios-envolvidos-btn-add-meio-close").click();
            return;
        }

        if( idMean === $('#id-meios-envolvidos-table tr td.id-means').html())
        {
            toastr["warning"]('Meio já seleccionado');
            return;
        }

        if (meanDescription == "Nenhum escolhido")
            meanDescription = "";

        myCivilProtectionTool._meiosEnvolvidosRowCounter++;
        var rowId = myCivilProtectionTool._meiosEnvolvidosRowCounter;
        var trId = `id-row-means-${rowId}`;
        var anchorId = `id-anchor-means-${rowId}`;

        let newContent = `<tr id="${trId}"><td class="hidden">${rowId}</td><td class="description">${meanDescription}</td><td class="hidden id-means">${idMean}</td><td><i><a id="${anchorId}" href="#" title="Remoção"><i class="material-icons">delete</i></a></i></td></tr>`;

        myCivilProtectionTool._hashReference['meios_envolvidos_list'].push({ "id": rowId, "meio": idMean });

        let tableBody = $("#id-offcanvas-body-layer-detail-meios-envolvidos-table-body");
        tableBody.append(newContent);

        $("#prop_meios-envolvidos_add_meio_div").addClass("hidden");
        $("#prop_meios-envolvidos_add_meio").val("");
        $("#prop_meios-envolvidos_add_buttons_div").addClass("hidden");

        $(`#${anchorId}`).off('click').on('click', function () {
            let arrayId = trId.split('-')[2];

            $(`#${trId}`).remove();

            myCivilProtectionTool._hashReference['meios_envolvidos_list'] = myCivilProtectionTool._hashReference['meios_envolvidos_list'].filter(function (element) {
                return element.id != arrayId;
            });
        });
    }

    /**
     * Add a note to a occurrence
     * @param {string} noteValue
     * @param {string} dateValue
     */
    this._AddNoteToOccurrence = function(noteValue, dateValue)
    {
        if (dateValue === "" & noteValue === "") {
            $("#id-offcanvas-body-layer-detail-notas-btn-add-nota-close").click();
            return;
        }

        if (dateValue !== "") {
            let dateTimeValues = dateValue.split('T');

            let dateValues = dateTimeValues[0].split('-');
            let timeValue = dateTimeValues[1];

            dateValue = `${dateValues[2]}/${dateValues[1]}/${dateValues[0]} ${timeValue}`;
        }

        myCivilProtectionTool._notasRowCounter++;
        var rowId = myCivilProtectionTool._notasRowCounter;
        var trId = `id-row-nota-${rowId}`;
        var anchorId = `id-anchor-nota-${rowId}`;

        let newContent = `<tr id="${trId}"><td class="hidden">${rowId}</td><td class="data">${dateValue}</td><td class="description">${noteValue}</td><td><i><a id="${anchorId}" href="#" title="Remoção"><i class="material-icons">delete</i></a></i></td></tr>`;

        myCivilProtectionTool._hashReference['notas_list'].push({ "id": rowId, "nota": noteValue, "data": dateValue });

        let tableBody = $("#id-offcanvas-body-layer-detail-notas-table-body");
        tableBody.append(newContent);

        $("#prop_notas_add_data_div").addClass("hidden");
        $("#prop_notas_add_data").val("")
        $("#prop_notas_add_nota_div").addClass("hidden");
        $("#prop_notas_add_nota").val("")
        $("#prop_notas_add_buttons_div").addClass("hidden");

        $(`#${anchorId}`).off('click').on('click', function () {
            let arrayId = trId.split('-')[2];

            $(`#${trId}`).remove();

            myCivilProtectionTool._hashReference['notas_list'] = myCivilProtectionTool._hashReference['notas_list'].filter(function (element) {
                return element.id != arrayId;
            });
        });
    }

    /**
     * Get all feature from a buffer
     */
    this._GetFeatureBufferForCombo = function(x, y, radius, geoserver, workspace, layerName, geomColumnName, idComboNode, valueSelect)
    {
        // Filter buffer
        var cqlFilterIntersect = 'DWITHIN(' + geomColumnName + ', POINT(' + x + ' ' + y + '), ' + radius + ', meters)';

        // Url
        var featureUrl = geoserver + "/wfs";

        var getFeature = $.ajax({
            method: "GET",
            async: false,
            url: featureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterIntersect,
                //"propertyName": 'geom',
                "outputFormat": 'application/json'
            }
        });

        getFeature.done(function (data, textStatus, jqXHR)
        {
            if (data.features)
            {
                if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameFreguesiaSection)
                {
                    myCivilProtectionTool._hashReferenceCombo["section"] = {};
                }
                if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameSectionPolice)
                {
                    myCivilProtectionTool._hashReferenceCombo["section_police"] = {};
                }
                var comboArray = [];
                var valueToSelect = valueSelect;
                var hashDistance = {};
                // For all feature
                for (var i = 0; i < data.features.length; i++)
                {
                    var feature =  (new GeoJSON()).readFeatures(data)[i];
                    // Feature freguesia
                    if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameFreguesia)
                    {
                        comboArray.push({ "id": feature.getProperties().IDFREGUESIA, "value": feature.getProperties().FREGUESIA });
                        if(!valueToSelect && myCivilProtectionTool._mapSgs.CheckFeaturePointInFeaturePolygon(myCivilProtectionTool._featureInfo.feature, feature))
                            valueToSelect = feature.getProperties().IDFREGUESIA;
                    }
                    // Feature freguesia section
                    if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameFreguesiaSection)
                    {
                        var distance = myCivilProtectionTool._mapSgs.GetDistanceBetweenPointAndLine(myCivilProtectionTool._featureInfo.feature, feature);
                        var obj = { "id": feature.getProperties().IDFREGUESIATROCO, "id_troco": feature.getProperties().IDTROCO, "value": feature.getProperties().RUA, "distance": distance };
                        if(myCivilProtectionTool._hashReferenceCombo["section"][feature.getProperties().IDFREGUESIA])
                            myCivilProtectionTool._hashReferenceCombo["section"][feature.getProperties().IDFREGUESIA].push(obj);
                        else
                            myCivilProtectionTool._hashReferenceCombo["section"][feature.getProperties().IDFREGUESIA] = [obj];
                    }
                    // Feature troco policia
                    if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameSectionPolice)
                    {
                        var distance = myCivilProtectionTool._mapSgs.GetDistanceBetween2Point(myCivilProtectionTool._featureInfo.feature, feature);
                        var obj = { "id": feature.getProperties().POL_SEQ, "id_troco": feature.getProperties().IDTROCO, "value": feature.getProperties().POL_DESIG, "distance": distance };
                        if(myCivilProtectionTool._hashReferenceCombo["section_police"][feature.getProperties().IDTROCO])
                            myCivilProtectionTool._hashReferenceCombo["section_police"][feature.getProperties().IDTROCO].push(obj);
                        else
                            myCivilProtectionTool._hashReferenceCombo["section_police"][feature.getProperties().IDTROCO] = [obj];
                    }
                }
                // Fill combo freguesia
                if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameFreguesia)
                {
                    myCivilProtectionTool._utility.FillSelect(idComboNode, comboArray, 'value', 'id', true);

                    $('#' + idComboNode).selectpicker('val', valueToSelect);
                }
                // Fill combo freguesia troco
                if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameFreguesiaSection)
                {
                    // Get from section identifier the freguesia section identifier
                    var idFreguesiaSelected = $('#prop_assoc_IDFREGUESIA').val();

                    if(valueToSelect !== "")
                    {
                        var sectionFreguesiaArray = myCivilProtectionTool._hashReferenceCombo["section"][idFreguesiaSelected];
                        if(sectionFreguesiaArray !== undefined)
                        {
                            var objSectionFreguesia = sectionFreguesiaArray.find(c=> c.id_troco === valueToSelect );
                            if( objSectionFreguesia !== undefined)
                            {
                                valueToSelect = objSectionFreguesia.id;
                            }
                        }
                    }

                    // Compose Object
                    for(var y = 0; y < Object.keys(myCivilProtectionTool._hashReferenceCombo["section"]).length; y++)
                    {
                        var idFreguesia = Object.keys(myCivilProtectionTool._hashReferenceCombo["section"])[y];
                        var comboArrayFreguesia = myCivilProtectionTool._hashReferenceCombo["section"][idFreguesia];
                        // sort array by troco name and distance
                        comboArrayFreguesia.sort(function(a,b){ if(a.value == b.value) return (a.distance > b.distance)?1:-1; return (a.value > b.value)?1:-1; } );
                        // get troços closer
                        var newComboArray = [];
                        comboArrayFreguesia.forEach(function(el, i) {
                            if(el.id === valueToSelect)
                            {
                                newComboArray.push(el);
                            }
                            else {
                                if(i==0)
                                    newComboArray.push(el);
                                else
                                {
                                    if(el.value != comboArrayFreguesia[i-1].value) newComboArray.push(el);
                                }
                            }
                        });
                        // Sort array by distance
                        newComboArray.sort(function(a,b){ return (a.distance > b.distance)?1:-1; } );
                        // Set the hash freguesia with new array
                        myCivilProtectionTool._hashReferenceCombo["section"][idFreguesia] = newComboArray;
                    }

                    // Set combo for the freguesia selected
                    if( idFreguesiaSelected !== undefined && idFreguesiaSelected !== "")
                    {
                        var comboArrayToView = myCivilProtectionTool._hashReferenceCombo["section"][idFreguesiaSelected];
                        if(comboArrayToView)
                        {
                            myCivilProtectionTool._utility.FillSelect(idComboNode, comboArrayToView, 'value', 'id', false);

                            if(!valueToSelect)
                                valueToSelect = comboArrayToView[0].id;
                            $('#' + idComboNode).selectpicker('val', valueToSelect);
                        }
                        else
                        {
                            // Clean section combo
                            myCivilProtectionTool._utility.FillSelect(idComboNode, [], 'value', 'id', false);

                            // Empty combo police
                            myCivilProtectionTool._utility.FillSelect('prop_assoc_NUMEROPOLICIA', [], 'value', 'id', false);
                        }
                    }
                    else
                    {
                        // Clean section combo
                        myCivilProtectionTool._utility.FillSelect(idComboNode, [], 'value', 'id', false);

                        // Empty combo police
                        myCivilProtectionTool._utility.FillSelect('prop_assoc_NUMEROPOLICIA', [], 'value', 'id', false);
                    }
                }
                // Fill combo troco policia
                if(layerName === myCivilProtectionTool._layerInformationFillField.layerNameSectionPolice)
                {
                    // Compose Object
                    for(var y = 0; y < Object.keys(myCivilProtectionTool._hashReferenceCombo["section_police"]).length; y++)
                    {
                        var idTroco = Object.keys(myCivilProtectionTool._hashReferenceCombo["section_police"])[y];
                        var comboArrayPolice = myCivilProtectionTool._hashReferenceCombo["section_police"][idTroco];
                        // sort array by police name and distance
                        comboArrayPolice.sort(function(a,b){ if(a.value == b.value) return (a.distance > b.distance)?1:-1; return (a.value > b.value)?1:-1; } );
                        // get police closer
                        var newComboArray = [];
                        comboArrayPolice.forEach(function(el, i) {
                            if(el.id === valueToSelect)
                            {
                                newComboArray.push(el);
                            }
                            else {
                                if(i==0)
                                    newComboArray.push(el);
                                else
                                {
                                    if(el.value != comboArrayPolice[i-1].value) newComboArray.push(el);
                                }
                            }
                        });
                        // Sort array by distance
                        comboArrayPolice.sort(function(a,b){ return (a.distance > b.distance)?1:-1; } );
                        // Set the hash freguesia with new array
                        myCivilProtectionTool._hashReferenceCombo["section_police"][idTroco] = comboArrayPolice;
                    }

                    // Set combo for the freguesia selected
                    var sectionFreguesiaArray = myCivilProtectionTool._hashReferenceCombo.section[$("#prop_assoc_IDFREGUESIA").val()];
                    if(sectionFreguesiaArray !== undefined)
                    {
                        var objSection = sectionFreguesiaArray.find(c=> c.id.toString() === $("#prop_assoc_IDTROCO").val());
                        let idSectionValue = (objSection !== undefined)?objSection.id_troco:"";

                        var comboArrayToView = myCivilProtectionTool._hashReferenceCombo["section_police"][idSectionValue];
                        if(comboArrayToView)
                        {
                            myCivilProtectionTool._utility.FillSelect(idComboNode, comboArrayToView, 'value', 'id', false);

                            if(valueToSelect)
                            {
                                var objPolice = comboArrayToView.find(c=> c.value === valueToSelect);
                                if( objPolice !== undefined)
                                {
                                    valueToSelect = objPolice.id;
                                }
                            }
                            else
                            {
                                valueToSelect = comboArrayToView[0].id;
                            }
                            $('#' + idComboNode).selectpicker('val', valueToSelect);
                        }
                        else
                        {
                            // Empty combo police
                            myCivilProtectionTool._utility.FillSelect(idComboNode, [], 'value', 'id', false);
                        }
                    }
                    else
                    {
                        // Empty combo police
                        myCivilProtectionTool._utility.FillSelect(idComboNode, [], 'value', 'id', false);
                    }
                }
            }
            else
            {
                // Set empty combo
                myCivilProtectionTool._utility.FillSelect(idComboNode, [], 'value', 'id', false);
            }
        });
    };


    /**
     * Change occurrence layer cql filter
     */
    this._ChangeOccurrenceLayerCqlFilter = function()
    {
        // Refresh all route layer
        var arraylayerInfo = myCivilProtectionTool._mapSgs.layerTree.FindAllLayerInfo(myCivilProtectionTool._LayerCivilProtectionName);
        for(var i = 0; i < arraylayerInfo.length; i++)
        {
            var layerInfo = arraylayerInfo[i];
            var idOperation = $('#id-civil-protection-operation-type-selected').val();
            if(idOperation === "")
                layerInfo.cqlFilter = layerInfo.cqlFilter.split(" and ")[0];
            else
                layerInfo.cqlFilter = layerInfo.cqlFilter.split(" and ")[0] + " and " + myCivilProtectionTool._civilProtectionIdOperationColumnName + "=" + idOperation;

            // Refresh layer info in layer tree in WFS request
            myCivilProtectionTool._mapSgs.layerTree.hashLayerNameKeyUpdatedLayerInfo[layerInfo.layerNameKey] = layerInfo;

            var layer = myCivilProtectionTool._mapSgs._utility.GetLayerByName(myCivilProtectionTool._mapSgs.map, layerInfo.layerNameKey);
            layer.getSource().clear();
        }
    }

    /**
     * Fill operation list for selection
     */
    this._FillOperationListForSelection = function()
    {
        var arrayOperation = myCivilProtectionTool._hashReference['operacoes_list'];

        for(var i = 0; i < arrayOperation.length; i++)
        {
            // Select first element
            if( i === 0)
            {
                // Set id operation selected
                $('#id-civil-protection-operation-type-selected').val(arrayOperation[i].id);

                // Set title operation selected
                $('#id-civil-protection-operation-type-button > span').html(arrayOperation[i].value);
            }

            $('#id-civil-protection-operation-type-button .dropdown-content').append($('<a id-operation="' + arrayOperation[i].id + '">' + arrayOperation[i].value + '</a>'));
        }

        // Refresh layer occurrence with operation selected
        myCivilProtectionTool._ChangeOccurrenceLayerCqlFilter();

        // Event click select operation
        $('#id-civil-protection-operation-type-button > .dropdown-content > a').on('click', function ()
        {
            // Set id operation selected
            $('#id-civil-protection-operation-type-selected').val($(this).attr('id-operation'));

            // Set title operation selected
            $('#id-civil-protection-operation-type-button > span').html($(this).html());

            // Hidde list operation
            $('#id-civil-protection-operation-type-button .dropdown-content').addClass('ol-hidden');

            // Refresh occurrence layer
            myCivilProtectionTool._ChangeOccurrenceLayerCqlFilter();
        });
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    $('#id-buttonsearchCivilProtectionTool').on('click', function () {
        myCivilProtectionTool._SearchCivilProtectionOccurrences();
    });

    /**
     * Event click button to view all operation
     */
    $('#id-civil-protection-operation-type-button > a').on('click', function ()
    {
        $('#id-civil-protection-operation-type-button .dropdown-content').toggleClass('ol-hidden');
    });

    // -- end event ----------------------------------------------------------------------------
};

/**
 * Init civil protection tool
 * @param {object} mapSgs, map object
 */
CivilProtectionTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // Layer civil protection name
        this._LayerCivilProtectionName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "LAYER_INFO", "LAYER_NAME").value;

        // Get civil protection identifier column name
        this._civilProtectionIdColumnName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "LAYER_INFO", "ID_COLUMN_NAME").value;

        // Get civil protection operation id column name
        this._civilProtectionIdOperationColumnName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "LAYER_INFO", "ID_OPERATION_COLUMN_NAME").value;

        // Get value open operation
        this._valueOpenOperation = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "OPERATION", "VALUE_OPEN_OPERATION").value;

        // Get value query type operation value
        this._valueQueryTypeOperation = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "TYPE_OPERATION", "CODE_QUERY").value;

        // -- Get all references -----------------------------------------------------------------
        this._GetAllReferences(this._valueQueryTypeOperation);

        // -- Get information layer not in layer tree ---------------------------------------------
        this._layerInformationFillField = {
            layerNameFreguesia: this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "LAYER_TO_FILL", "LAYER_NAME_FREGUESIA").value,
            layerNameFreguesiaSection: this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "LAYER_TO_FILL", "LAYER_NAME_FREGUESIA_TROCO").value,
            layerNameSectionPolice: this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CIVIL_PROTECTION_TOOL", "LAYER_TO_FILL", "LAYER_NAME_TROCO_NPOLICIA").value,
        }
        this._utility.GetLayerInformation(this._layerInformationFillField.layerNameFreguesia, this._layerInformation);
        this._utility.GetLayerInformation(this._layerInformationFillField.layerNameFreguesiaSection, this._layerInformation);
        this._utility.GetLayerInformation(this._layerInformationFillField.layerNameSectionPolice, this._layerInformation);
    }
};